import { useQuery } from "@tanstack/react-query";
import { getPostById } from "@/api/post";

export const usePost = (id, options = {}) => {
  return useQuery({
    queryKey: ["blogs", "post", id],
    queryFn: () => getPostById(id),
    enabled: !!id,
    ...options,
  });
};
